import React from "react";
import { Trans, useTranslation } from "react-i18next";
import PageHeader from "components/common/PageHeader";
import EmbeddedWorkspaceV2App from "./EmbeddedWorkspaceV2App";
const ExternalLink = ({ href, children }) => /* @__PURE__ */ React.createElement("a", { href, rel: "noopener noreferrer", target: "_blank" }, children);
const WorkspaceV2App = () => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("googleworkspacev2.app.title") }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "googleworkspacev2.app.description",
      components: {
        bigQueryLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://cloud.google.com/bigquery" }),
        exportLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://support.google.com/a/topic/9079469" })
      }
    }
  ))), /* @__PURE__ */ React.createElement(EmbeddedWorkspaceV2App, null));
};
export default WorkspaceV2App;
